/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
	SET_PROPERTY_TYPES(state, propertyTypes) {
		state.propertyTypes = propertyTypes
		state.loading = false
	},
	FETCH_PROPERTY_TYPES(state) {
		state.loading = true
	}
}
